import {useEffect, useState} from 'react';
import queryString from 'query-string';
import {CircularProgress} from '@material-ui/core';
import {useRecoilState} from 'recoil';
import useSearchQuery from '../../services/reactQueryHook/useSearchQuery';
import SearchBar from '../SearchBar/SearchBar';
import getAlphanumericText from '../../utilis/getAlphanumericText';
import {loadingState} from '../../atoms';
import SearchResults from '../SearchResults/SearchResults';

const Search = () => { 
  const parsed = queryString.parse(window.location.search);
  const [text, setText] = useState(typeof parsed.isin === 'string' ? parsed.isin : '');
  const {data, isFetched} = useSearchQuery(getAlphanumericText(text));
  const [loading] = useRecoilState(loadingState);

  useEffect(() => {
    if (text && text !== parsed.isin) {
      window.history.replaceState(null, '', `?${queryString.stringify({isin: text})}`)
    }
  }, [parsed.isin, text]);

  return (
    <div>
      {loading && <div className="overlay">
        <CircularProgress className={'spinner'}/>
      </div>}
        
      <SearchBar onSearch={setText} defaultValue={text}/>
      {isFetched && <SearchResults documents={data} />}
    </div>
  )
}

export default Search
